export const usuario = {
  nombre: "Margarita Tymoszuk",
  email: "magui@tymoszuk.com.ar",
  matricula: "CUCICBA 7842",
  organizacion: "Tymoszuk Propiedades",
  licencia: { estado: "activa", vencimiento: "15/08/2026", tipo: "mensual" },
};

export const tasaciones = [
  {
    id: 1,
    estado: "formal",
    tipo: "departamento",
    direccion: "Av. Rivadavia 4520, P3 A",
    partido: "Caballito, CABA",
    sup_cubierta: 68,
    ambientes: 2,
    valor_estimado_usd: 127500,
    valor_min_usd: 119000,
    valor_max_usd: 135000,
    precio_publicacion_usd: 132000,
    precio_realizacion_usd: 121000,
    margen_negociacion_pct: 8.3,
    valor_m2_usd: 1875,
    cochera: true,
    ascensor: true,
    banos: 1,
    created_at: "2026-06-21",
    cliente: { nombre: "Roberto Fernández", telefono: "11 4523-8901" },
    comparables: [
      { id: 1, fuente: "Argenprop", direccion: "Rivadavia 4480, P4 A", precio_usd: 128000, sup_cubierta: 65, precio_m2_usd: 1969, ambientes: 2, dias_publicado: 3 },
      { id: 2, fuente: "Argenprop", direccion: "Méndez de Andes 720", precio_usd: 135000, sup_cubierta: 70, precio_m2_usd: 1928, ambientes: 2, dias_publicado: 7 },
      { id: 3, fuente: "Argenprop", direccion: "Av. Rivadavia 4560", precio_usd: 119000, sup_cubierta: 62, precio_m2_usd: 1919, ambientes: 2, dias_publicado: 14 },
      { id: 4, fuente: "Properati", direccion: "Rojas 145, P2", precio_usd: 122000, sup_cubierta: 64, precio_m2_usd: 1906, ambientes: 2, dias_publicado: 21 },
      { id: 5, fuente: "Properati", direccion: "Av. Rivadavia 4350", precio_usd: 138000, sup_cubierta: 72, precio_m2_usd: 1916, ambientes: 3, dias_publicado: 30 },
    ],
  },
  {
    id: 2,
    estado: "en_proceso",
    tipo: "casa",
    direccion: "Urquiza 210",
    partido: "Ezeiza, GBA Sur",
    sup_cubierta: 120,
    ambientes: 4,
    valor_estimado_usd: null,
    cochera: true,
    ascensor: false,
    banos: 2,
    created_at: "2026-06-18",
    cliente: null,
    comparables: [],
  },
  {
    id: 3,
    estado: "borrador",
    tipo: "local",
    direccion: "Salta 88",
    partido: "Canning, GBA Sur",
    sup_cubierta: 45,
    ambientes: null,
    valor_estimado_usd: null,
    cochera: false,
    ascensor: false,
    banos: 1,
    created_at: "2026-06-15",
    cliente: null,
    comparables: [],
  },
  {
    id: 4,
    estado: "formal",
    tipo: "ph",
    direccion: "Gral. Paz 1240, PH B",
    partido: "Monte Grande, GBA Sur",
    sup_cubierta: 95,
    ambientes: 3,
    valor_estimado_usd: 185000,
    valor_min_usd: 175000,
    valor_max_usd: 195000,
    precio_publicacion_usd: 190000,
    precio_realizacion_usd: 178000,
    margen_negociacion_pct: 6.3,
    valor_m2_usd: 1947,
    cochera: true,
    ascensor: false,
    banos: 2,
    created_at: "2026-06-10",
    cliente: { nombre: "Laura Gómez", telefono: "11 6712-3344" },
    comparables: [],
  },
];

export const cucicbaReferencial = {
  zona: "Caballito",
  valor_min: 1820,
  valor_max: 2150,
  unidad: "USD/m²",
  fuente: "CUCICBA",
  fecha: "Junio 2026",
};
